<template>
    <div class="wrapper">
        <popup-modal :show="show && askForWheel">
            <template #content>
                <p class="message">Wil jij met een rad bepalen wie er moet beginnen met delen?</p>
            </template>
            <template #footer>
                <div class="buttons">
                    <custom-button class="button" variation="white" size="medium" @click="$emit('close')">Nee</custom-button>
                    <custom-button class="button" size="medium" @click="handleUseWheel">Ja</custom-button>
                </div>
            </template>
        </popup-modal>
        <popup-modal :show="show && showWheel" blur absolute>
            <template #absolute>
                <wheel-of-fortune :users="users"></wheel-of-fortune>
                <div class="footer">
                    <custom-button class="button" size="medium" @click="$emit('close')">Terug naar het spel</custom-button>
                </div>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import WheelOfFortune from '@/views/WheelOfFortune';
import PopupModal from '@/components/PopupModal.vue';
import CustomButton from '@/components/CustomButton.vue';

export default {
    name: 'wheel-select-modal',
    components: {
        WheelOfFortune,
        PopupModal,
        CustomButton
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        users: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            askForWheel: true,
            showWheel: false
        }
    },
    methods: {
        handleUseWheel() {
            this.askForWheel = false;
            this.showWheel = true;
        }
    }
}
</script>

<style lang="scss" scoped>

.buttons {
    display: flex;
    gap: 12px;
    width: 100%;
}

.footer {
    flex-grow: 1;
}

</style>